module.exports = __webpack_public_path__ + "static/media/fow.2f3592b9.vert";